import Api from './Api';
import AppConfiguration from './AppConfiguration';

/**
 * This class represents a connection to the backbone api.
 * It has all the endpoints wrapped in methods that can be called directly.
 */
export default class BackboneApi extends Api {
  constructor() {
    // Get all the configs
    const config = AppConfiguration.getConfig();

    // Only use the backbone config for this Api subclass
    super(config.backboneApi);
  }

  /**
   * Sends a request to the imageSession endpoint to get a session id from an image
   *
   * @param {Object} image An Image blob object to append to the request
   * @returns {Promise} The promise returned by the request.
   */
  getImageSession(image) {
    // Use FormData to construct the needed structure of the request
    const requestBody = new window.FormData();

    // Append the file passed as parameter
    requestBody.append('imageFile', image);

    // Since an image is sent in binary form, we need to add specific headers
    const headers = {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    // Send the request and return the promise generated
    return Api.post(this.getEndpoint('imageSession'), requestBody, headers);
  }

  /**
   * Sends a request to the imageSession endpoint to get a session id from an image
   *
   * @param {Object} image An Image blob object to append to the request
   * @returns {Promise} The promise returned by the request.
   */
  validateUserLogin(token) {
    // Use FormData to construct the needed structure of the request
    const requestBody = new window.FormData();

    // Append the file passed as parameter
    requestBody.append('token', token);

    // Since an image is sent in binary form, we need to add specific headers
    const headers = {
      withCredentials: true,
      headers: { 'content-type': 'multipart/form-data' },
    };

    // Send the request and return the promise generated
    return Api.post(this.getEndpoint('AuthZeroTokenLogin'), requestBody, headers);
  }

  /**
   * Get the price of the selected fonts.
   * @param {Object} body       The body of the request to send.
   * @property {Array} targets  An array of objects that specifies the fonts configurations. Each element of the array
   *                            corresponds to a different font style.
   *
   * @example
   *  body = {
   *    targets = [
   *      {
   *        targetID: 1,
   *        targetType: 1,
   *        license: {
   *          licenseType: 1,
   *          licenseQuantity: 1,
   *        },
   *      },
   *      {
   *        targetID: 2,
   *        targetType: 1,
   *        license: {
   *          licenseType: 1,
   *          licenseQuantity: 1,
   *        },
   *      },
   *    ]
   *  }
   *
   * @returns {Promise}
   */
  getFontPrice(body) {
    return Api.post(this.getEndpoint('prices'), body);
  }
}



// WEBPACK FOOTER //
// ./src/services/BackboneApi.js